import PropTypes from "prop-types";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import Paragraphs from "app/pages/.shared/Paragraphs";
import "./GoodToKnow.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const GoodToKnow = ({ description }) => {
	return (
		<div className="good-to-know">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL}
				isBold
				className="good-to-know__headline"
				component="h3"
			>
				<FormattedMessage id="useful.information.good.to.knows.headline" />
			</Typography>
			<div className="good-to-know__description">
				<Paragraphs paragraphs={description} enableHTMLFormatting={true} />
			</div>
		</div>
	);
};

GoodToKnow.propTypes = {
	description: PropTypes.arrayOf(PropTypes.string),
};

GoodToKnow.defaultProps = {
	description: [],
};

export default memo(GoodToKnow);
